export default class CustomizationAbstract {
    /**
     * Pre-requisite: the variable confLocale should store an object with
     * at least the following infos:
     *   localDefaultConf.server.lang
     *   localDefaultConf.server.notes
     *   localDefaultConf.server.url_Css
     */
    constructor(localDefaultConf) {
        this.localDefaultConf = localDefaultConf;
    }
    // [High level] Get the individual configuration
    ///
    getCurrencyName() {
        return this.getServerConfig('name');
    }
    getContract1() {
        return this.getServerConfig('contract_1');
    }
    getContract2() {
        return this.getServerConfig('contract_2');
    }
    getContract3() {
        return this.getServerConfig('contract_3');
    }
    getHelpUrl() {
        return this.getServerConfig('url_help');
    }
    getCondUrl() {
        return this.getServerConfig('url_cond');
    }
    getUnlockUrl() {
        return this.getServerConfig('url_unlock');
    }
    getHowToUrl() {
        return this.getServerConfig('url_howto');
    }
    getWalletAddress() {
        return this.getServerConfig('address');
    }
    getCreationMessage() {
        return this.getServerConfig('creat_message');
    }
    getLang() {
        var _a;
        return this.getServerConfig('lang') || ((_a = this.localDefaultConf.server) === null || _a === void 0 ? void 0 : _a.lang);
    }
    getNoteValues() {
        var _a;
        return this.getServerConfig('notes') || ((_a = this.localDefaultConf.server) === null || _a === void 0 ? void 0 : _a.notes);
    }
    hasBn() {
        return !!this.getNoteValues();
    }
    hasNant() {
        return this.getServerConfigSwitch('nant', false);
    }
    hasCM() {
        return this.getServerConfigSwitch('CM', false);
    }
    hasAutor() {
        return this.getServerConfigSwitch('autor', false);
    }
    hasDeleg() {
        return this.getServerConfigSwitch('deleg', false);
    }
    hasPayRequest() {
        return this.getServerConfigSwitch('payReq', false);
    }
    passwordAutocomplete() {
        let number = 10000;
        try {
            if (this.cfg.server.passwordAutocomplete &&
                this.cfg.server.passwordAutocomplete > 0) {
                number = this.cfg.server.passwordAutocomplete;
            }
        }
        catch (e) {
        }
        return number;
    }
    getCurrencies() {
        return this.getServerConfig('currencies');
    }
    // ///////////////////////////////////////////////////////////////////////////
    getServerConfig(configName) {
        try {
            return this.cfg.server[configName];
        }
        catch (e) {
            return '';
        }
    }
    getServerConfigSwitch(configName, defaultValue) {
        try {
            return this.cfg.server[configName].toString().toLowerCase() === 'true';
        }
        catch (e) {
            return defaultValue;
        }
    }
    // ///////////////////////////////////////////////////////////////////////////
    getCurrencyAssetBaseUrl(currencyName) {
        if (!currencyName) {
            currencyName = this.cfg.server.name;
        }
        if (!this.cfg.custoRepo) {
            throw Error('Requested getCurrencyAssetBaseUrl while configuration is not available (yet?)');
        }
        return `${this.cfg.custoRepo}${currencyName}`;
    }
    getCssUrl(currencyName) {
        try {
            // XXXvlab: I guess that we don't need to keep 'etherwallet' css
            // names
            return this.getCurrencyAssetBaseUrl(currencyName) +
                '/css/etherwallet-master.min.css';
        }
        catch (e) {
            console.log('`customization.getCssUrl(..)` called before configuration was ' +
                "ready. Returning `localDefaultConf`'s value.");
            return this.localDefaultConf.server.url_Css;
        }
    }
    getCurrencyLogoUrl(currencyName) {
        try {
            // XXXvlab: I guess that 'lem' stands for leman here. Shouldn't that
            // be agnostic ?
            return `${this.getCurrencyAssetBaseUrl(currencyName)}/images/lem.png`;
        }
        catch (e) {
            console.log('`customization.getCurrencyLogoUrl(..)` called before configuration ' +
                'was ready. Returning empty string.');
            return '';
        }
    }
}
//# sourceMappingURL=customization.js.map